import RenderManager from "sap/ui/core/RenderManager";
import Library from "sap/ui/core/Lib";
import ObjectIdentifierWithSubtitle from "./ObjectIdentifierWithSubtitle";
import { EmptyIndicatorMode } from "sap/m/library";
import helper from "../../model/helper"

var oRb = Library.getResourceBundleFor("sap.m");

export default {
	apiVersion: 2,

	render: function (oRm: RenderManager, oOI: ObjectIdentifierWithSubtitle) {
		var sTooltip;

		// Return immediately if control is invisible
		if (!oOI.getVisible()) {
			return;
		}

		// write the HTML into the render manager
		oRm.openStart("div", oOI); // Identifier begins
		oRm.class("sapMObjectIdentifier");

		sTooltip = oOI.getTooltip_AsString();
		if (sTooltip) {
			oRm.attr("title", sTooltip);
		}

		oRm.openEnd();

		oRm.openStart("div"); // Top row begins
		oRm.class("sapMObjectIdentifierTopRow");
		if (!oOI._hasTopRow()) {
			oRm.style("display", "none");
		}

		oRm.openEnd();

		oRm.openStart("div", oOI.getId() + "-title"); // Title begins
		oRm.class("sapMObjectIdentifierTitle");

		oRm.openEnd();
		if (oOI.getTitle()) {
			oRm.renderControl(oOI._getTitleControl());
		}

		oRm.close("div"); // Title ends

		oRm.openStart("div"); // Icons begin
		oRm.class("sapMObjectIdentifierIcons");

		oRm.openEnd();

		oRm.close("div"); // Icons end

		oRm.close("div"); // Top row ends

		if (oOI.getEmptyIndicatorMode() !== EmptyIndicatorMode.Off && helper.isEmptyOrSpaces(oOI.getSubtitle())) {
			this.renderEmptyIndicator(oRm, oOI);
		} else {
			if (!helper.isEmptyOrSpaces(oOI.getSubtitle())) {
				oRm.openStart("div", oOI.getId() + "-subtitle"); // Subtitle begins
				oRm.class("sapMObjectIdentifierText");
	
				oRm.openEnd();
				if (oOI.getSubtitle()) {
					oRm.renderControl(oOI._getSubtitleControl());
				}
				oRm.close("div"); // Subtitle ends
			}
		}

		if (oOI.getEmptyIndicatorMode() !== EmptyIndicatorMode.Off && !oOI.getText()) {
			this.renderEmptyIndicator(oRm, oOI);
		} else {
			oRm.openStart("div", oOI.getId() + "-text"); // Text begins
			oRm.class("sapMObjectIdentifierText");

			if (oOI.getProperty("text") && oOI.getProperty("title")) {
				oRm.class("sapMObjectIdentifierTextBellow");
			}
			oRm.openEnd();
			if (oOI.getText()) {
				oRm.renderControl(oOI._getTextControl());
			}
			oRm.close("div"); // Text ends
		}

		oRm.close("div"); // Identifier ends
	},

	renderEmptyIndicator: function(oRm: RenderManager, oOI: ObjectIdentifierWithSubtitle) {
		oRm.openStart("span");
		oRm.class("sapMEmptyIndicator");
		if (oOI.getEmptyIndicatorMode() === EmptyIndicatorMode.Auto) {
			oRm.class("sapMEmptyIndicatorAuto");
		}
		oRm.openEnd();
		oRm.openStart("span");
		oRm.attr("aria-hidden", true);
		oRm.openEnd();
			oRm.text(oRb.getText("EMPTY_INDICATOR"));
		oRm.close("span");
		//Empty space text to be announced by screen readers
		oRm.openStart("span");
		oRm.class("sapUiPseudoInvisibleText");
		oRm.openEnd();
			oRm.text(oRb.getText("EMPTY_INDICATOR_TEXT"));
		oRm.close("span");
	oRm.close("span");
	}
  };